import { render, staticRenderFns } from "./FszPie.vue?vue&type=template&id=05b9b8da&scoped=true"
import script from "./FszPie.vue?vue&type=script&lang=js"
export * from "./FszPie.vue?vue&type=script&lang=js"
import style0 from "./FszPie.vue?vue&type=style&index=0&id=05b9b8da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b9b8da",
  null
  
)

export default component.exports